var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-loading", {
        attrs: { "is-full-page": false },
        model: {
          value: _vm.isLoading,
          callback: function ($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading",
        },
      }),
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("consignee.stock.summary.estimated_stock_in_volume")
            ) +
            " "
        ),
      ]),
      _c(
        "b-table",
        { attrs: { data: _vm.stock } },
        [
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_NAME",
              label: _vm.$t("consignee.stock.summary.customer"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.CUSTOMER_NAME) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_COUNTRY",
              label: _vm.$t("consignee.stock.summary.country"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("img", {
                      staticStyle: { "max-height": "15px" },
                      attrs: {
                        src: `https://flagcdn.com/w20/${props.row.CUSTOMER_COUNTRY.toLowerCase()}.png`,
                        alt: "english flag",
                      },
                    }),
                    _vm._v(" " + _vm._s(props.row.CUSTOMER_COUNTRY) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_CITY",
              label: _vm.$t("consignee.stock.summary.city"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.CUSTOMER_CITY) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_ADDRESS",
              label: _vm.$t("consignee.stock.summary.address"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.CUSTOMER_NAME) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "IN_STOCK",
              label: _vm.$t("consignee.stock.summary.stock"),
              numeric: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.IN_STOCK) + " ")]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("h1", { staticClass: "title second" }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("consignee.stock.summary.estimated_stock_scanned")) +
            " "
        ),
      ]),
      _c(
        "b-table",
        { attrs: { data: _vm.stockScan } },
        [
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_NAME",
              label: _vm.$t("consignee.stock.summary.customer"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.CUSTOMER_NAME) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_COUNTRY",
              label: _vm.$t("consignee.stock.summary.country"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("img", {
                      staticStyle: { "max-height": "15px" },
                      attrs: {
                        src: `https://flagcdn.com/w20/${props.row.CUSTOMER_COUNTRY.toLowerCase()}.png`,
                        alt: "english flag",
                      },
                    }),
                    _vm._v(" " + _vm._s(props.row.CUSTOMER_COUNTRY) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_CITY",
              label: _vm.$t("consignee.stock.summary.city"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.CUSTOMER_CITY) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER_ADDRESS",
              label: _vm.$t("consignee.stock.summary.address"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(" " + _vm._s(props.row.CUSTOMER_ADDRESS) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "COUNT_BARCODES",
              label: _vm.$t("consignee.stock.summary.barcodes"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.COUNT_BARCODES) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "AVG_ON_SITE_ELAPSED_DAYS",
              label: _vm.$t("consignee.stock.summary.average_on_site_days"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.row.AVG_ON_SITE_ELAPSED_DAYS.slice(
                            0,
                            props.row.AVG_ON_SITE_ELAPSED_DAYS.indexOf(".")
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "CUSTOMER",
              label: _vm.$t("consignee.stock.summary.detail"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("b-button", {
                      attrs: {
                        size: "is-small",
                        type: "is-link",
                        "icon-left": "barcode",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goToDetail(props.row.CUSTOMER)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }